module.exports = __webpack_public_path__ + "static/media/logo-rueducommerce--squared.9c328ccb.png";